import PageIndicator from '@components/page-indicator/PageIndicator';
import PageLink from '@components/page-link/PageLink';
import Pagination from '@components/pagination/Pagination';
import { PAGINATION_LIMIT } from '@constants/generic';

interface TablePageIndicatorProps {
  currentPage: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  limit?: number;
}

const TablePageIndicator = ({
  currentPage,
  totalCount,
  onPageChange,
  limit = PAGINATION_LIMIT
}: TablePageIndicatorProps) => (
  <div className="mt-2 flex w-full items-center justify-between">
    <PageIndicator page={currentPage} totalCount={totalCount} limit={limit} />
    <Pagination
      page={currentPage}
      setPage={onPageChange}
      totalCount={totalCount}
      limit={limit}
    />
    <PageLink
      page={currentPage}
      setPage={onPageChange}
      totalCount={totalCount}
      limit={limit}
    />
  </div>
);

export default TablePageIndicator;
